import {version}         from '../package.json';
import HBProviderManager from './header-bidding/provider-manager';
import app               from './application';
import ConfigManager     from './config-manager';
import {
  cargaLibreriaGPT,
  isEmpty
} from './utils';
import {
  showLog,
  showWarn,
  showError
} from './logger';
import {
  GPT_READY,
  GPT_TIMEOUT,
  TIMEOUT_POSICIONES_ESTANDAR,
  POSITION_FLUID,
  SLOT_RENDERED,
  SLOT_EMPTY,
  SLOT_VIEWABLE,
  HEADER_BIDDING_READY
} from './constants';

var
  _configManager          = null,
  _standardDelayed        = [],
  _gptInitialized         = false,
  _insertedPositions      = {},
  _notDisplayedSlots      = [],
  _completadasPriorizadas = false
;

class Advertising {
  /**
   * Function that initialize the advertising
   * @param {object}  app - Evented object
   * @param {object}  configGDPMedio
   * @param {object}  configGDP
   * @param {context} context$
   */
  static init(configManager, context$) {
    var kruxSegments, kruxUser;

    _configManager          = null;
    _standardDelayed        = [];
    _gptInitialized         = false;
    _insertedPositions      = {};
    _notDisplayedSlots      = [];
    _completadasPriorizadas = false;

    _configManager           = configManager;
    _configManager.context$  = context$;

    // Detectamos si se fuerza via URL alguna configuracion
    _configManager.checkConfigFromURL();

    if (!_configManager.configGDPMedio.activo) {
      showWarn('Advertising:init:The advertising has been deactivated in the configuration of the medium!');
      return;
    }
    showLog(`Advertising:init:deviceType: ${_configManager.deviceType} , pageType: ${_configManager.pageType} , (Version ${version})`);

    _configManager.processConfig();

    // Load HB and GPT libraries soon as posible for not penalize the ad visualization
    showLog('init:HeaderBidding init');
    HBProviderManager.init(_configManager.configGDPMedio);
    cargaLibreriaGPT();

    // Inicializacion de la libreria GPT
    window.customcmd.push(function() {
      window.googletag.pubads().collapseEmptyDivs();
      kruxSegments = app.lookup('Krux.vocento.segments');
      kruxUser     = app.lookup('Krux.vocento.user');
      if (_configManager.configGDPMedio.enableKrux
        && ['object', 'undefined'].indexOf(typeof kruxSegments) < 0
        && ['object', 'undefined'].indexOf(typeof kruxUser) < 0
      ) {
        window.googletag.pubads().setTargeting('ksg',  window.Krux.vocento.segments);
        window.googletag.pubads().setTargeting('kuid', window.Krux.vocento.user);
      }
      _configManager.configGDPMedio.singleRequest &&
      window.googletag.pubads().enableSingleRequest();
      _configManager.configGDPMedio.syncRendering &&
      window.googletag.pubads().enableSyncRendering();
      window.googletag.enableServices();

      // Disparamos el evento de GPT inicializada
      showLog(`En constructor. Disparamos evento ${GPT_READY}`);
      app.trigger(GPT_READY);
      _gptInitialized = true;
    });

    /* NOTE: Disparamos el evento de GPT inicializado tras N segundos para liberar posibles
             recursos que esten bloqueados */
    setTimeout(function () {
      if (!_gptInitialized) {
        showWarn(`Advertising:init:Trigger event ${GPT_READY} after ${GPT_TIMEOUT}`);
        app.trigger(GPT_READY);
      }
    }, GPT_TIMEOUT);

    // Tratamiento de excepciones
    _configManager.checkExceptions();

    // Gestion de eventos de pintado de publicidad
    window.customcmd.push(function () {
      // Gestion de evento slotRenderEnded
      window.googletag.pubads().addEventListener('slotRenderEnded', function (ev) {
        var divId, position, container$, paramsSlot, index, found;

        divId      = ev.slot.getSlotElementId();
        position   = ev.slot.getTargeting('pos');
        container$ = $(`#${divId}`);
        paramsSlot = container$.data('params');
        index      = -1;

        if (ev.isEmpty) {
          showLog(`En constructor. slotRenderEnded. La posicion ${position} isEmpty`);
          container$.trigger(SLOT_EMPTY);
          if (_configManager.configGDPMedio.infoSlot) _infoSlotRender(paramsSlot, false);
        } else {
          showLog(`En constructor. slotRenderEnded. La posicion ${position} ha sido pintada en el DIV ${divId}`);
          container$.trigger(SLOT_RENDERED);
          if (_configManager.configGDPMedio.infoSlot) _infoSlotRender(paramsSlot, true);
        }

        // Comprobacion si tiene eventos post_callback o post_event
        if (paramsSlot) {
          if (paramsSlot.post_callback) {
            showLog(`En constructor. slotRenderEnded. La posicion ${position} tiene el siguiente postCallback: ${paramsSlot.post_callback}`);
            paramsSlot.post_callback();
          }

          if (paramsSlot.post_event) {
            showLog(`En constructor. slotRenderEnded. La posicion ${position} tiene el siguiente postEvent: ${paramsSlot.post_event}`);
            app.trigger(paramsSlot.post_event);
          }
        }

        // Quitamos la posicion de la lista de posiciones priorizadas
        _configManager.removePrioritizedPosition();

        // Quitamos la posicion de la lista de posiciones estandar encoladas
        if (_configManager.thereArePrioritizedPositions() &&
          _standardDelayed.length && !_configManager.isPrioritized(paramsSlot)
        ) {
          found = _standardDelayed.find(function(parameters) {
            index++;
            return parameters.position === position[0];
          });
          if (found) {
            _standardDelayed.splice(index, 1);
          }
        }

        // Si esta era la ultima priorizada pintamos las estandar
        if (!_completadasPriorizadas && (!_configManager.thereArePrioritizedPositions())) {
          _completadasPriorizadas = true;
          _displayStandarQueued();
        }
      });

      // Gestion de evento impressionViewable
      window.googletag.pubads().addEventListener('impressionViewable', function (ev) {
        var divId = ev.slot.getSlotElementId();
        var position = ev.slot.getTargeting('pos');
        var container$ = $(`#${divId}`);

        showLog(`En constructor. impressionViewable. La posicion ${position} es visible`);
        container$.trigger(SLOT_VIEWABLE);
      });
    });

    /* NOTE: Si hay posiciones priorizadas las pintamos e invocamos el pintado de las estandar
             una vez pintadas estas */
    if (_configManager.thereArePrioritizedPositions()) {
      _displayPrioritized();

      /* NOTE: Si han transcurrido N segundos y todavia no se han lanzado las posiciones
               estandar las forzamos */
      setTimeout(function () {
        if (_standardDelayed.length) {
          showWarn(`Advertising:init:Display queued positions after ${TIMEOUT_POSICIONES_ESTANDAR}`);
          _completadasPriorizadas = true;
          _displayStandarQueued();
        }
      }, TIMEOUT_POSICIONES_ESTANDAR);
    }
  }

  /**
   * Muestra la Advertising.
   * @param {Object} datos - Puede ser un DIV obtenido con jQuery con los atributos de
   *                         configuracion, o bien un objeto JSON con la configuracion a aplicar
   *
   * Descripcion de parametros que puede contener el objeto JSON:
   *      position      => string. Posicion publicitaria a mostrar
   *      id            => string. ID del elemento HTML en el que se muestra
   *      serverType    => string. Servidor de publicidad a usar
   *      hideNoAds     => boolean. Oculta el elemento HTML si el adserver no ha devuelto publi
   *      outOfPage     => boolean. Determina si el slot de publicidad es outOfPage o no. Por
   *                                defecto vale false
   *      defineSlot    => boolean. Indica si hay que definir o no el slot
   *      refresh       => boolean. Se pide la posicion de publicidad aunque ya se hubiera mostrado
   *                                antes. Por defecto false
   *      responsive    => Array. Indicamos si una publi se debe pintar solo en una(s)
   *                              determinada(s) resolucion(es)
   *      pre_callback  => function. Función javascript a la que invocar previamente
   *      pre_event     => string. evento de precondicion
   *      post_callback => function. Función javascript a la que invocar una vez disparado
   *                                 el slotRendered
   *      post_event    => string. evento a disparar una vez disparado evento de slotRendered
   *      oas           => string. Si se rellena es el OAS a utilizar en la posicion de publicidad
   *
   * Objeto Responsive
   *  El primer par de valores indica la resolucion, y en el segundo los tamanos de la posicion de
   *  publi a servir, el cual puede definirse como sigue:
   *    - vacio: []
   *    - single array: [ancho, alto]
   *    - multi array: [ [ancho1, alto1], [ancho2, alto2], ... ]
   *  - string: En cuyo caso usa la funcion ads.getSizesGoogle para obtener el array
   *
   * Ejemplo llamada:
   *  ads.printAds({'position': 'robapaginas', 'id': 'roba2', 'responsive': [
   *       [[0, 0], []] // Small Mobile
   *         ,[[350, 200], [300,150]] // Mobile
   *         ,[[750, 200], 'robapaginas'] // Tablet
   *         ,[[1050, 300], [[300,150],[300,250]]] // Desktop
   *   ]});
   */
  static printAds(datos) {
    var params, position, idAds, prioritized, delayed;

    showLog('Advertising:printAds', datos);
    if (!_configManager.configGDPMedio.activo) {
      showWarn('Advertising:printAds:Ads was be disabled in Media Config');
      return;
    }

    params = _configManager.normalizaParams(datos);
    if (params === null) {
      showWarn('Advertising:printAds:Empty params', datos);
      return;
    }

    position = params.position;
    idAds = _configManager.getIdDiv(params);
    if (!_configManager.isActive(params)) {
      if ($(`#${idAds}`).length && params.hideNoAds) {
        showWarn('Advertising:printAds:Hiding ADs DIV container if hideNoAds is anabled', params);
        $(`#${idAds}`).hide();
      }
      showWarn(`Advertising:printAds:Position ${position} is not active`, params);
      return;
    }

    if (!$(`#${idAds}`).length) {
      showWarn(`Advertising:printAds:DIV with ID ${idAds} does not exist`, params);
      return;
    }

    if (params.serverType === 'google') {
      /* NOTE: Si estamos en modo preview comprobamos si esta posicion hay que traerla desde el
               SW del capturador */
      if (_configManager.configGDPMedio.preview && _capturadorExistsPreview(params)) {
        showLog('Advertising:printAds:Preview mode. Getting form grabber service');
        _capturadorSetPreview(params);
        return;
      }

      showLog('Advertising:printAds:Check Ad-Type', params);
      prioritized = _configManager.isPrioritized(position);
      delayed =     _configManager.isDelayed(position);

      if (prioritized && !delayed) {
        showLog('Advertising:printAds:Painting prioritized', params);
        _getAdGoogle(params, true);
      } else if (delayed) {
        showLog('Advertising:printAds:Wait for INVIEW event delayed', params);
        _displayDelayed(params);
      } else if (!_configManager.thereArePrioritizedPositions() || _completadasPriorizadas) {
        showLog('Advertising:printAds:Painting standard', params);
        _getAdGoogle(params, false);
      } else {
        showLog('Advertising:printAds:Painting queued standards', params);
        _standardDelayed.push(params);
      }
    } else {
      showWarn('Advertising:printAds:ServerType is different from google', params);
    }
  }

  /**
   * Get user type
   * NOTE: legacy code
   */
  static getValueUser() {
    if (!_configManager) {
      throw Error('Advertising:getValueUser:Config object not initialized');
    }

    return _configManager.valueUserType;
  }

  /**
   * Get google sizes for a given position
   * NOTE: legacy code
   */
  static getSizesGoogle(...params) {
    if (!_configManager) {
      throw Error('Advertising:getSizesGoogle:Config object not initialized');
    }

    return _configManager.getSizesGoogle(...params);
  }

  /**
   * Get OAS value from config
   * NOTE: legacy code
   */
  static getOasSitepage(...params) {
    if (!_configManager) {
      throw Error('Advertising:getOasSitepage:Config object not initialized');
    }

    return _configManager.getOasSitepage(...params);
  }
}

export default Advertising;

/* Private */

/**
 * Funcion que genera el scriptText que pinta la Advertising.
 * @param  object params
 */
function _defineSlot(params) {
  var
    scriptText, legacyCmvkey, insertedPositionkey, hideText, targetingText, size, idAds,
    targetingsTags, deviceTypeTargeting, decryptedURL, pattern, isValid, decodedURLTargetings,
    chunksURLTargetings, topics, mappingObj, sizeMapping, defineSizeMapping
  ;

  size           = _configManager.getSizesGoogle(params.position);
  idAds          = _configManager.getIdDiv(params);
  targetingsTags = params.tags || {};
  // Codigo para ocultar el div si no hay publi
  hideText = params.hideNoAds ? '.setCollapseEmptyDiv(true)' : '';
  targetingText  = _configManager.globalTargetings;

  Object.keys(targetingsTags).forEach(function(key) {
    targetingText += `.setTargeting("${key}", "${targetingsTags[key]}")`;
  });

  // Targeting con tipo de usuario de Gigya
  deviceTypeTargeting = _configManager.deviceType === 'mobile' ? 'm' : 'w';
  targetingText += `.setTargeting('st', '${_configManager.valueUserType}').setTargeting('stt', '${deviceTypeTargeting}${_configManager.valueUserType}')`;

  // Se comprueba si se fuerza algun targeting via URL con el parametro vam_cmvkey
  decryptedURL = ConfigManager.decryptedURL();
  if (((typeof window.location !== 'undefined') && (window.location.href.indexOf('vam_cmvkey=') > -1 || window.location.href.indexOf('cmvkey=') > -1)) || (decryptedURL !== '')) {
    legacyCmvkey = window.location.href.indexOf('vam_cmvkey=') > -1 ? 'vam_cmvkey' : 'cmvkey';
    pattern = new RegExp(`(\\?|&)${legacyCmvkey}=([^?&]+)`);
    isValid = (decryptedURL !== '') ? pattern.exec(decryptedURL) : pattern.exec(window.location.href);

    if (isValid) {
      try {
        decodedURLTargetings = decodeURIComponent(isValid[2]);
        chunksURLTargetings = decodedURLTargetings.split(',');

        chunksURLTargetings.forEach(function(chunck) {
          var pair, keyChunk, valueChunk;

          pair = chunck.split('=');
          keyChunk = pair[0];
          valueChunk = pair[1];
          targetingText += `.setTargeting("${keyChunk}", "${valueChunk}")`;
        });
      } catch (e) {
        showWarn(`Advertising:defineSlot:Error processing ${legacyCmvkey}: ${e}`);
      }
    }
  }

  // Incluimos los topics como targeting si asi corresponde
  try {
    topics = _getTopics(false);
    if (topics.length) {
      targetingText += `.setTargeting("topics", "${topics}")`;
    }
  } catch (e) {
    showWarn(`Advertising:defineSlot:Error processing enableTopics: ${e}`);
  }

  // Se comprueba si enableTpag esta habilitado
  try {
    if (_configManager.configGDPMedio.enableTpag) {
      targetingText += `.setTargeting("tpag", "${_configManager.pageType}")`;
    }
  } catch (e) {
    showWarn(`Advertising:defineSlot:Error processing tpag: ${e}`);
  }

  // Comprobaciones para medios responsives
  mappingObj = {};
  sizeMapping = '';
  defineSizeMapping = '';
  if (!params.outOfPage && params.responsive &&
      Array.isArray(params.responsive) && params.responsive.length > 0) {
    mappingObj = _getSizeMapping(params);
    sizeMapping       = mappingObj && mappingObj.definition ? mappingObj.definition : '';
    defineSizeMapping = mappingObj && mappingObj.script     ? mappingObj.script     : '';
  }

  if (!params.outOfPage) {
    if (params.defineSlot) {
      scriptText = `${sizeMapping}window.${_getNombreSlot(params)} = window.googletag.defineSlot('${_configManager.getOasSitepage(params)}', ${size}, '${idAds}')${defineSizeMapping}.setTargeting('pos','${params.position}')${targetingText}${hideText}.addService(googletag.pubads());`;
    }
  } else if (params.defineSlot) {
    scriptText = `${sizeMapping}window.${_getNombreSlot(params)} = window.googletag.defineOutOfPageSlot('${_configManager.getOasSitepage(params)}', '${idAds}')${defineSizeMapping}.setTargeting('pos','${params.position}')${targetingText}${hideText}.addService(googletag.pubads());`;
  }

  insertedPositionkey = _getClavePosicionInsertada(params);
  _insertedPositions[insertedPositionkey] = scriptText;
  showLog('Advertising:defineSlot:Ads ID', idAds);
  window.customcmd.push(_executeDefineSlot(scriptText, params));
}

function _executeDefineSlot(scriptText, params) {
  showLog(`En defineSlot. defineSlot: ${scriptText}`);
  eval(scriptText);
  _notDisplayedSlots.push(params.position);
}

/**
 * Hace display de una posicion
 */
function _display(params) {
  // Comprobamos si la posicion esta en la lista de posiciones definidas y pendientes de display
  var index, idDiv;

  showLog(`Advertising:display:Display position ${params.position} with params`, params);
  index = _notDisplayedSlots.indexOf(params.position);
  if (index < 0) {
    showLog(`Advertising:display:Position ${params.position} has already been displayed`);
    return;
  }

  showLog(`Advertising:display:Position ${params.position} is not displayed yet`);
  idDiv = _configManager.getIdDiv(params);
  if (!$('#' + idDiv).length) {
    showWarn(`Advertising:display:DIV with ID ${idDiv} does not exist`);
    return;
  }
  showLog(`Advertising:display:Queued position ${params.position} to display`);
  window.customcmd.push(function () {
    showLog(`Advertising:display:Displaying ${params.position}`);
    window.googletag.display(idDiv);

    /* NOTE: Si singleRequest esta habilitado un unico display sirve para todas las posiciones
              para las que hemos hecho defineSlot previamente. En caso contrario solo quitamos la
              posicion concreta de la lista.
    */
    if (_configManager.configGDPMedio.singleRequest) {
      _notDisplayedSlots = [];
    } else {
      _notDisplayedSlots.splice(index, 1);
    }
  });
}

/**
 * Funcion que obtiene las medidas en caso de que sea responsive.
 * FUTURE: move config to GDP
 * FUTURE: move logic to GoogleTag component
 * @param  object responsive
 * @return string sizeMapping
 */
function _getSizeMapping(params) {
  var mappingName, mappingObj, responsive, finalDefinition;

  mappingName = `window.mapping_${_getNombreSlot(params)}`;
  mappingObj = {
    definition: `${mappingName} = window.googletag.sizeMapping()`,
    script:     `.defineSizeMapping(${mappingName})`
  };
  responsive = params.responsive;
  showLog(`Advertising:getSizeMapping:Resposive param for position ${params.position}`, responsive);

  finalDefinition = responsive.reduce(function(definition, pair) {
    var addSize, viewportSize, responsiveSizes, singleSize;

    if (definition !== '' && !definition) return undefined;

    viewportSize = pair[0];
    if (pair.length !== 2 || !Array.isArray(viewportSize) || viewportSize.length !== 2) {
      showWarn(`Advertising:getSizeMapping:Malformed responsive param in position ${params.position}. responsive: ${responsive}`);
      return undefined;
    }

    addSize         = '';
    responsiveSizes = pair[1];
    if (typeof responsiveSizes === 'string') {
      if (responsiveSizes.indexOf('fluid') !== -1) {
        responsiveSizes = POSITION_FLUID;
      } else {
        responsiveSizes = _configManager.getSizesGoogle(responsiveSizes);
        if ((typeof responsiveSizes !== 'undefined') && (typeof responsiveSizes === 'string')) {
          responsiveSizes = JSON.parse(responsiveSizes);
        }
      }
    }
    if (!Array.isArray(responsiveSizes) && responsiveSizes !== POSITION_FLUID) {
      showWarn(`Advertising:getSizeMapping:Malformed responsive param in position ${params.position}. responsive: ${responsive}`);
      return undefined;
    }

    addSize = '[' + viewportSize[0] + ',' + viewportSize[1] + '],';
    if (responsiveSizes.length > 0 && Array.isArray(responsiveSizes[0])) {
      addSize += '[';
      for (let j = 0; j < responsiveSizes.length; j++) {
        singleSize = responsiveSizes[j];
        if (singleSize.length === 2) {
          addSize += (j === 0 ? '[' : ',[') + singleSize[0] + ',' + singleSize[1] + ']';
        }
      }
      addSize += ']';
    } else if (responsiveSizes.length === 2) {
      addSize += '[' + responsiveSizes[0] + ',' + responsiveSizes[1] + ']';
    } else if (responsiveSizes === POSITION_FLUID) {
      addSize += POSITION_FLUID;
    } else {
      addSize += '[]';
    }

    return `${definition}.addSize(${addSize})`;
  }, '');

  if (!finalDefinition) return undefined;

  mappingObj.definition += `${finalDefinition}.build();`;

  return mappingObj;
}

/**
 * Lanza los printAds que se han encolado cuando hay priorizadas
 */
function _displayStandarQueued() {
  showLog('Advertising:displayStandarQueued:Display queued positions');
  while (_standardDelayed.length) {
    Advertising.printAds(_standardDelayed.shift());
  }
}

/**
 * Funcion para pintar la publicidad priorizada
 */
function _displayPrioritized() {
  showLog(`Advertising:pintaPriorizadas:Painting the following positions : ${_configManager.prioritizedPositions}`);
  _pintaListaPosiciones(_configManager.prioritizedPositions, true);
}

/**
 * Funcion que recorre y pinta una lista de posiciones.
 * Si singleRequest esta habilitado las posiciones priorizadas funcionan como un Roadblock y se
 * piden todas juntas (no llevaran eventos ni callbacks)
 */
function _pintaListaPosiciones(listaPositions, sonPosicionesPriorizadas) {
  if (_configManager.configGDPMedio.singleRequest && sonPosicionesPriorizadas) {
    showLog('Advertising:pintaListaPosiciones:There is prioritized positions and SingleRequest is enabled -> get with Roadblock');

    window.customcmd.push(function () {
      var params, container$, posCuyoDivExiste;

      posCuyoDivExiste = null;
      listaPositions.forEach(function(position) {
        params = {position};

        if (!_configManager.existePosEnConfigGDPMedio(position)) {
          showWarn(`Advertising:pintaListaPosiciones:SingleRequest position ${position} does not exist configGDPMedio`);
          return;
        }

        if (!_configManager.isActive(params)) {
          showWarn(`Advertising:pintaListaPosiciones:SingleRequest position ${position} is NOT active`);
          return;
        }

        // Recuperamos los parametros del DIV en caso de que exista en la pagina
        container$ = $(`[data-voc-vam-position = '${position}']`, _configManager.context$);
        if (container$.length) {
          params = _configManager.normalizaParams(container$);
          if (posCuyoDivExiste === null) posCuyoDivExiste = params;
        } else {
          // NOTE: find legacy DIV
          container$ = $(`#${_configManager.getIdDiv(params)}`);
          if (container$.length) {
            params = _configManager.normalizaParams(params);
            if (posCuyoDivExiste === null) {posCuyoDivExiste = params;}
          } else {
            showWarn(`En pintaListaPosiciones. No existe el DIV de la posicion priorizada ${position}`);
          }
        }
        if ('id' in params) {
          showLog(`En pintaListaPosiciones. Llamando a defineSlot: ${JSON.stringify(params)}`);
          _defineSlot(params);
        }
      });

      if (posCuyoDivExiste === null) {
        showError('ERROR En pintaListaPosiciones. No existe el DIV de ninguna de las posiciones priorizadas en la pagina, por lo que no se hara el display');
      } else {
        params = posCuyoDivExiste;
      }

      // NOTE: If there is Header Bidding wait for bidders promises
      if (HBProviderManager.isActive()) {
        showLog('pintaListaPosiciones:Waiting for HB`s promises to be solved');
        app.when(HEADER_BIDDING_READY).then(function() {
          showLog('pintaListaPosiciones:HB promises resolved');
          HBProviderManager.setTargetings();
          showLog('pintaListaPosiciones:Params object', params);
          _display(params);
        });
      } else {
        showLog('En pintaListaPosiciones. Print without wait HB');
        _display(params);
      }
    });
  } else {
    !_configManager.configGDPMedio.singleRequest && showLog('Advertising:pintaListaPosiciones:SingleRequest DISABLED');
    !sonPosicionesPriorizadas                    && showLog('Advertising:pintaListaPosiciones:There are NOT prioritized positions');
    // window.customcmd.push(function () {
    listaPositions.forEach(function(position) {
      var params, container$, legacyParams;

      if (!_configManager.existePosEnConfigGDPMedio(position)) {
        showWarn(`Advertising:pintaListaPosiciones:Prioritized position ${position} does not exist configGDPMedio`);
        return;
      }

      params = {position};
      if (!_configManager.isActive(params)) {
        showWarn(`Advertising:pintaListaPosiciones:Prioritized position ${position} is NOT active`);
        return;
      }

      // Recuperamos los paramteros del DIV en caso de que exista en la pagina
      container$ = $(`[data-voc-vam-position = '${position}']`, _configManager.context$);
      if (container$.length) {
        params = _configManager.normalizaParams(container$);
      } else {
        container$ = $(`#${_configManager.getIdDiv(params)}`);
        if (container$.length) {
          legacyParams = _configManager.normalizaParams(container$);
        }
        params = !legacyParams ? _configManager.normalizaParams(params) : legacyParams;
      }

      showLog('Advertising:pintaListaPosiciones:Calling printAds with', params);
      Advertising.printAds(params);
    });
    // });
  }
}

/**
 * Display delayed positions when it is on viewport
 * @param {object} params
 */
function _displayDelayed(params) {
  var idAds = _configManager.getIdDiv(params);

  $(`#${idAds}`).on('inview', function (event, isInView) {
    showLog('Advertising:displayDelayed:INVIEW_EVENT trigger', params, event, isInView);
    if (isInView) {
      showLog('Advertising:displayDelayed:Painting delayed', idAds, params);
      _getAdGoogle(params, false);
    }
  });
}

/**
 * Pintado de publicidad de GPT
 */
function _getAdGoogle(params, esPosPriorizada) {
  if (!_configManager.configGDPMedio.activo) {
    showWarn('Advertising:getAdGoogle:Ads was be disabled in Media Config');
    return;
  }

  showLog('Advertising:getAdGoogle:Queuing with', params);
  window.customcmd.push(function() {
    var idDiv, eventParams, tParams, key, hasPreevent;

    if (!_configManager.existePosEnConfigGDPMedio(params.position)) {
      showWarn(`Advertising:getAdGoogle:Position ${params.position} does not exist in configGDPMedio`);
      return;
    }

    showLog('Advertising:getAdGoogle:googletag exec with', params);
    idDiv       = _configManager.getIdDiv(params);
    eventParams = _getEventsPosition(params);

    tParams = params;
    tParams.pre_callback = eventParams.pre_callback;
    tParams.pre_event = eventParams.pre_event;

    tParams.post_callback = eventParams.post_callback;
    tParams.post_event = eventParams.post_event;
    showLog('Advertising:getAdGoogle:Set params to DIV with id = ', idDiv);
    $(`#${idDiv}`).data('params', tParams);

    key = _getClavePosicionInsertada(params);
    if (!_insertedPositions[key]) {
      hasPreevent = false;
      if (params.defineSlot) {
        showLog('Advertising:getAdGoogle:defineSlot', params);
        _defineSlot(params);
        if (!esPosPriorizada) {
          showLog('Advertising:getAdGoogle:It is not prioritized', params);
          if (eventParams.pre_callback && !eventParams.pre_event) {
            eventParams.pre_callback();
          } else if (eventParams.pre_event) {
            showLog('Advertising:getAdGoogle:Has pre-event', params);
            hasPreevent = true;
            app.one(eventParams.pre_event, params, function () {
              // NOTE: If there is Header Bidding wait for bidders promises
              if (HBProviderManager.isActive()) {
                showLog('Advertising:getAdGoogle:Waiting for HB`s promises to be solved');
                app.when(HEADER_BIDDING_READY).then(function() {
                  showLog('Advertising:getAdGoogle:HB promises resolved with preEvents', params);
                  if (params.pre_callback) {
                    params.pre_callback();
                  }
                  HBProviderManager.setTargetings();
                  _display(params);
                });
              }
            });
          } else {
            showLog('Advertising:getAdGoogle:Has NO pre-event', params);
            if (HBProviderManager.isActive()) {
              hasPreevent = true;
              showLog('Advertising:getAdGoogle:Waiting for HB`s promises to be solved');
              app.when(HEADER_BIDDING_READY).then(function() {
                showLog('Advertising:getAdGoogle:HB promises resolved without preEvents with', params);
                if (params.pre_callback) {
                  params.pre_callback();
                }
                HBProviderManager.setTargetings();
                _display(params);
              });
            }
          }
        } else {
          showLog('Advertising:getAdGoogle:Is prioritized', params);
          if (HBProviderManager.isActive()) {
            hasPreevent = true;
            showLog('Advertising:getAdGoogle:Waiting for HB`s promises to be solved');
            app.when(HEADER_BIDDING_READY).then(function() {
              showLog('Advertising:getAdGoogle:HB promises resolved on prioritized position with', params);
              HBProviderManager.setTargetings();
              _display(params);
            });
          }
        }
      }

      // No tiene evento de activacion
      if (!hasPreevent) {
        showLog('Advertising:getAdGoogle:Has no pre-event. Painting', params);
        HBProviderManager.setTargetings();
        _display(params);
      }
    } else {
      showLog(`Advertising:getAdGoogle:Position ${params.position} has already been previously invoked. Checking the value of the refresh parameter`, params.refresh);
      if (params.refresh) _pintarPosicionRefresh(params);
    }
  });
}

/**
 * Funcion que recuperar si tiene evento pre o post callback, los parametros llegados por funcion
 * prevalecen sobre los del CONFIG
 * @param  object params
 */
function _getEventsPosition(params) {
  var tipoDispositivoAux, positionEvents;

  tipoDispositivoAux = _configManager.deviceType;
  positionEvents = app.lookup(`posicion_${tipoDispositivoAux}["${params.position}"]`, _configManager.configGDP);

  if (isEmpty(positionEvents)) return positionEvents;

  positionEvents.pre_callback  = params.pre_callback  || params.pre_callback;
  positionEvents.pre_event     = params.pre_event     || params.pre_event;
  positionEvents.post_callback = params.post_callback || params.post_callback;
  positionEvents.post_event    = params.post_event    || params.post_event;

  return positionEvents;
}

/**
 * Devuelve el nombre de la variable que almacenara el slot
 */
function _getNombreSlot(params) {
  var dynamicId, dynamic;

  dynamicId = _configManager.dynamicId;
  dynamic   = dynamicId ? `_${dynamicId}` : '';

  return `slot_${params.position.replace('-', '_')}${dynamic}`;
}

/**
 * Clave unica de la posicion
 */
function _getClavePosicionInsertada(params) {
  return _getNombreSlot(params) + '_' + _configManager.getIdDiv(params);
}

/**
 * Refresh de una posicion
 */
function _pintarPosicionRefresh(params) {
  showLog(`En pintarPosicionRefresh. Refrescamos la posicion ${params.position}`);
  window.googletag.pubads().refresh([app.lookup(_getNombreSlot(params))]);
}

/**
 * INICIO: Renderizado de tablas de informacion cuando vam_info_slot=1
 * --------------------------------------------------------------------------
 */
/**
 * Metodo de entrada de tablas de informacion
 */
function _infoSlotRender(params, isSlotRendered) {
  var idDiv, container$, width, height, dimension, arrayObj, numSlots, numTopics, numOas, max;

  idDiv      = _configManager.getIdDiv(params);
  container$ = $(`#${idDiv}`);
  width      = $(`#${idDiv} div iframe`).width();
  height     = $(`#${idDiv} div iframe`).height();

  // Obtenemos el tamano de la publi pintada y la borramos
  if (isSlotRendered) {
    container$.empty();
  } else {
    // Si DFP devuelve isEmpty cogemos la primera dimension del array, o 150x150 si es fluid
    try {
      height = 150;
      width  = 150;
      dimension = _configManager.getSizesGoogle(params.position);
      if (dimension && dimension.indexOf('fluid') < 0) {
        arrayObj = JSON.parse(dimension);

        if (Array.isArray(arrayObj[0])) {
          width = arrayObj[0][0];
          height = arrayObj[0][1];
        } else {
          width = arrayObj[0];
          height = arrayObj[1];
        }
      }
    } catch (e) {
      showError('Advertising:infoSlotRender:Error building size.', e);
    }

    container$.show();
  }

  // Rectangulo con color azul o rojo (si es local)
  container$.addClass('gdp_infoSlot_rectangle').html(`<div><p style="width: ${width}px; height: ${height}px;">${params.position} ${_infoSlotFormateaDimensiones(params)}</p></div>`);
  if (_isLocalPosition(params)) container$.addClass('gdp_infoSlot_localPosition');
  if (!isSlotRendered) container$.addClass('gdp_infoSlot_inactive');

  if (!$('#gdp_infoSlot_tableInfo').length > 0) {
    $('body').append('<div class="display" id="gdp_infoSlot_tableInfo"></div>');
  }

  // Tablas de info adicional
  _infoSlotRenderSlots(params);
  _infoSlotRenderTopics();
  _infoSlotRenderOAS(params);

  numSlots  = $('#gdp_infoSlot_tableInfo-slots').length > 0  ? $('#gdp_infoSlot_tableInfo-slots tbody tr').length  : 0;
  numTopics = $('#gdp_infoSlot_tableInfo-topics').length > 0 ? $('#gdp_infoSlot_tableInfo-topics tbody tr').length : 0;
  numOas    = $('#gdp_infoSlot_tableInfo-oas').length > 0    ? $('#gdp_infoSlot_tableInfo-oas tbody tr').length    : 0;
  max       = Math.max(numSlots, numTopics);
  if (max > numSlots && $('#gdp_infoSlot_tableInfo-slots').length > 0) {
    for (let i = 0; i < max - numSlots; i++) {
      $('#gdp_infoSlot_tableInfo-slots tbody').append('<tr><td>&nbsp;</td></tr>');
    }
  }
  if (max > numTopics && $('#gdp_infoSlot_tableInfo-topics').length > 0) {
    for (let i = 0; i < max - numTopics; i++) {
      $('#gdp_infoSlot_tableInfo-topics tbody').append('<tr><td>&nbsp;</td></tr>');
    }
  }
  if (max > numOas && $('#gdp_infoSlot_tableInfo-oas').length > 0) {
    for (let i = 0; i < max - numOas; i++) {
      $('#gdp_infoSlot_tableInfo-oas tbody').append('<tr><td>&nbsp;</td></tr>');
    }
  }
}

function _applyFilter(value) {
  return value
    .replace(new RegExp("'fluid'", 'g'), '[fluid]')
    .replace(new RegExp('\\],\\[', 'g'), '_')
    .replace(new RegExp(',', 'g'), 'x')
    .replace(new RegExp('\\[', 'g'), '')
    .replace(new RegExp('\\]', 'g'), '')
    .replace(new RegExp('_', 'g'), ',');
}

function _infoSlotFormateaDimensiones(params) {
  var
    result, dimensionsArray, mappingObj, sizeMapping,
    dimension, resolution, notRepeatedDimensions;

  result          = '';
  dimensionsArray = [];
  mappingObj      = {};
  sizeMapping     = '';

  try {
    if (params.outOfPage) {
      dimensionsArray.push('oop');
    } else if (params.responsive &&
        Array.isArray(params.responsive) &&
        params.responsive.length > 0
    ) {
      mappingObj = _getSizeMapping(params);
      sizeMapping = ((typeof mappingObj !== 'undefined') && (typeof mappingObj.definition !== 'undefined')) ? mappingObj.definition : '';
      sizeMapping.split('.').forEach(function(size) {
        if (size.indexOf('addSize') > -1) {
          size = size.replace(new RegExp('addSize\\(', 'g'), '').replace(new RegExp('\\)', 'g'), '');
          dimensionsArray.push(size);
        }
      });
    } else {
      dimensionsArray.push(app.lookup(`posicion_${_configManager.deviceType}["${params.position}"].dimensiones`, _configManager.configGDPMedio));
    }

    if (Array.isArray(dimensionsArray)) {
      if (params.outOfPage) { // Posicion OutOfPage
        result += '(oop)';
      } else if (!params.responsive) { // Posicion no responsive
        dimension = _applyFilter(dimensionsArray[0]);
        result += '(' + dimension + ')';
      } else { // Posicion responsive
        notRepeatedDimensions = new Set();
        dimensionsArray.forEach(function(dimen) {
          var filtered = _applyFilter(dimen);

          // Quitamos la resolucion
          resolution = filtered.substring(0, filtered.indexOf(','));
          dimension  = filtered.substring(filtered.indexOf(',') + 1);
          notRepeatedDimensions.add(dimension);
          result += '<br>' + resolution + ': (' + dimension + ')';
        });

        // Si todas las dimensiones de responsive son la misma escribimos solo una
        if (notRepeatedDimensions.size === 1) result = '(' + dimension + ')';
      }
    }
  } catch (err) {
    showError('Advertising:infoSlotFormateaDimensiones:Error', err);
  }

  return result;
}

/**
 * Tabla de informacion de SLOTS
 */
function _infoSlotRenderSlots(params) {
  if (!$('#gdp_infoSlot_tableInfo-slots').length) {
    $('#gdp_infoSlot_tableInfo').append('<table cellpadding="0" cellspacing="0" border="1" class="display" id="gdp_infoSlot_tableInfo-slots"><thead></thead><tbody></tbody></table>');
    $('#gdp_infoSlot_tableInfo-slots thead').append('<th>posiciones</th>');
  }
  $('#gdp_infoSlot_tableInfo-slots tbody').append(`<tr><td>${params.position}</td></tr>`);
}

/**
 * Tabla de informacion de TOPICS
 */
function _infoSlotRenderTopics() {
  var topics = _getTopics(true);
  if (topics.length > 0) {
    if (!$('#gdp_infoSlot_tableInfo-topics')) {
      $('#gdp_infoSlot_tableInfo').append('<table cellpadding="0" cellspacing="0" border="1" class="display" id="gdp_infoSlot_tableInfo-topics" ><thead></thead><tbody></tbody></table>');
      $('#gdp_infoSlot_tableInfo-topics thead').append('<th>topics</th>');

      topics.forEach(function(topic) {
        $('#gdp_infoSlot_tableInfo-topics tbody').append(`<tr><td>${topic}</td></tr>`);
      });
    }
  }
}

/**
 * Tabla de informacion de OAS
 */
function _infoSlotRenderOAS(params) {
  if (!$('#gdp_infoSlot_tableInfo-oas')) {
    $('#gdp_infoSlot_tableInfo').append('<table cellpadding="0" cellspacing="0" border="1" class="display" id="gdp_infoSlot_tableInfo-oas"><thead></thead><tbody></tbody></table>');
    $('#gdp_infoSlot_tableInfo-oas thead').append('<th>oas</th>');
    $('#gdp_infoSlot_tableInfo-oas tbody').append(`<tr><td>${_configManager.getOasSitepage(params)}</td></tr>`);
  }
}

/**
 * Devuelve un array con los topics que contiene la pagina, en caso de que los contenga y que
 * enableTopics este habilitado.
 * @return array
 */
function _getTopics(forzarEnableTopics) {
  var topics = [];

  if ((_configManager.configGDPMedio.enableTopics || forzarEnableTopics) && window.voc_top) {
    topics = window.voc_top.split(',');
  }

  return topics;
}

/**
 * Funcion que devuelve true si la posicion es local, false si no lo es
 * @return boolean
 */
function _isLocalPosition(params) {
  return params.position.includes('_local');
}
/**
 * FIN: Renderizado de tablas de informacion cuando vam_info_slot=1
 * --------------------------------------------------------------------------
 */


/**
 * INICIO: Capturador (modo preview)
 * --------------------------------------------------------------------------
 */

/**
 * Devuelve true si hay preview para la posicion indicada o false en caso contrario
 * @returns {boolean}
 */
function _capturadorExistsPreview(params) {
  return _configManager.capturadorDataPreview &&
         _configManager.capturadorDataPreview[params.position];
}

/**
 * funcion que cambia la publicidad por defecto, por una que se indica
 */
function _capturadorSetPreview(params) {
  var previewJSON, preview, idDiv, div, creatividad;

  try {
    previewJSON = JSON.parse(_configManager.capturadorDataPreview[params.position]);
    preview     = previewJSON[0];
    idDiv       = _configManager.getIdDiv(params);
    creatividad = `<iframe id="${idDiv}-iframe" name="${preview.name}" src="${preview.previewUrl}" width="${preview.size.width}" height="${preview.size.height}" scrolling="no" frameborder="0"></iframe>`;
    div         = $(`#${idDiv}`);
    div.empty();
    div.html(creatividad);
    showLog(`En capturadorSetPreview. Pintada preview para la posicion ${params.position}`);
  } catch (err) {
    showError('Advertising:capturadorSetPreview:Error', err);
  }
}
/**
 * FIN: Capturador (modo preview)
 * --------------------------------------------------------------------------
 */



// WEBPACK FOOTER //
// ./src/advertising.js